import { Avatar } from "@material-ui/core";
import React from "react";
import "../../css/Profile/ProfileHeader.css";
import { useStateValue } from "../../StateProvider";

function ProfileHeader({ profile }) {
  const [{ user, userProfile }] = useStateValue();

  return (
    <div className="profileHeader">
      <div className="profileHeader__image">
        <img
          src="https://images.unsplash.com/photo-1506533159314-92937d1ea0f3?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=750&q=80"
          alt=""
        />
      </div>

      <div className="profileHeader__info__container">
        <div className="profileHeader__info">
          <Avatar
            className="profileHeader__info__image classes.large"
            src={profile.photoURL}
          />
          <h3>{profile.name}</h3>
        </div>
      </div>
    </div>
  );
}

export default ProfileHeader;
